<app-loader-initial *ngIf="loading$ | async" [smallLoader]="smallLoader"></app-loader-initial>

<app-loader-list-scroll *ngIf="scrolling$ | async"></app-loader-list-scroll>
